"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { kycOnboarding } from "@/content/agent-use-cases/kyc-onboarding";

export default function KycOnboardingUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={kycOnboarding} locale={locale} />;
}
